import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enable chat to native mobile app user
 */
export const HELP_CENTER_CHAT_MOBILE_230329 =
  'HELP_CENTER_CHAT_MOBILE_230329' as SettingConst<
    'HELP_CENTER_CHAT_MOBILE_230329',
    boolean,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
